/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Used
 *
 * 2 = New
 *
 * 3 = ExDemo
 *
 * 4 = DeliveryMileage
 */
export enum AITemplateType {
  Used = 1,
  New = 2,
  ExDemo = 3,
  DeliveryMileage = 4,
}
